import {Address} from "@/scripts/Common";

const createNewAddress = () => {
    const address: Address = {
        id: 0,
        street: '',
        town: '',
        zipCode: '',
    }

    return address;
}

const resetAddressObject = (originalObject: Address, changedObject: Address) => {
    changedObject.id = originalObject.id;
    changedObject.town = originalObject.town;
    changedObject.street = originalObject.street;
    changedObject.zipCode = originalObject.zipCode;
}

const addressHasChanges = (originalObject: Address, changedObject: Address) => {
    return changedObject.id !== originalObject.id
        || changedObject.town !== originalObject.town
        || changedObject.street !== originalObject.street
        || changedObject.zipCode !== originalObject.zipCode;
}

export {
    createNewAddress,
    resetAddressObject,
    addressHasChanges
}
